export const REPORT_STATE_SELECTOR = "reportAffiliates";
export const REPORT_COLUMNS_KEY = "[REPORT ==> affiliates] Visible columns is:";
export const REPORT_DATE_KEY = "[REPORT ==> affiliates] Date range is: ";
